export const mbfRankCard_style = {
  rootSx: {
    display: 'flex',
    AlignItems: 'center',
    justifyContent: 'center',
  },
};
